import { OPENED_IMAGE_CROPPER, CLOSED_IMAGE_CROPPER, IMAGE_CROPPER_CONFIG_CHANGED } from '../constants/actionTypes';

export const openImageCropper = () => ({
    type: OPENED_IMAGE_CROPPER,
});

export const closeImageCropper = () => ({
    type: CLOSED_IMAGE_CROPPER,
});

export const setConfig = (props) => ({
    type: IMAGE_CROPPER_CONFIG_CHANGED,
    ...props,
});
